import {
   AppointmentAdvancePayment,
   AppointmentAdvancePaymentRefundCommand,
} from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { Money } from '@dreryk/money-common-api';

import { moneySubtract } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

type AdvancePaymentRefundActionEventInterceptorProps = Readonly<{
   advancePayment: AppointmentAdvancePayment;
   children: JSX.Element;
}>;

export const AdvancePaymentRefundActionEventInterceptor = (
   props: AdvancePaymentRefundActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: refundAppointmentAdvancePayment } = useCqrsCommand<void, void>(
      () => {
         const command = new AppointmentAdvancePaymentRefundCommand();
         command.appointmentAdvancePaymentId = props.advancePayment.id;
         const refundAmount = moneySubtract(
            props.advancePayment.paidAmount.asNumber(),
            props.advancePayment.requiredAmount.asNumber()
         );
         command.amount = Money.of(refundAmount);
         return command;
      },
      {
         onSuccess: () => dispatchSnackbarPositiveEvent(translationKeys.overpaymentRefundRequested),
      }
   );

   return <ActionEventInterceptor action={refundAppointmentAdvancePayment}>{props.children}</ActionEventInterceptor>;
};
